exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".time__time__k_aVD{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;line-height:16px;color:hsla(0,0%,100%,.8);font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;text-decoration:-wix-fonts-textFont-decoration;font-size:12px}.time__time__k_aVD.time__at-full-screen__2GJxr{font-size:14px}.time__time__current__1P8cs{margin-right:5px}.time__time__duration__3Pmug{margin-left:5px}", ""]);

// exports
exports.locals = {
	"time": "time__time__k_aVD",
	"at-full-screen": "time__at-full-screen__2GJxr",
	"atFullScreen": "time__at-full-screen__2GJxr",
	"time__current": "time__time__current__1P8cs",
	"timeCurrent": "time__time__current__1P8cs",
	"time__duration": "time__time__duration__3Pmug",
	"timeDuration": "time__time__duration__3Pmug"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/player-widget/components/player/controls/time/time.styl
// module id = 1307
// module chunks = 0 1 2 3